export default __webpack_public_path__ + "static/media/hammer-mockup.71992287.png";